import { createFileRoute } from '@tanstack/react-router';

type Search = {
  utm_source?: string;
  mailer?: string;
  flow_type?: string;
  email?: string;
  v?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/portal/accept-invite_/$nonceToken_/location_/$locationId')({
  staticData: { team: 'fe-clm' },
  validateSearch: (search: Search) => search,
});
